<template>
<div>
    <Row style="margin-top: 8px" :gutter="10" justify="center" type="flex">
        <Col span="24">
                <RadioGroup v-model="requestType">
                    <Radio label="Approve"></Radio>
                    <Radio label="Reject"></Radio>
                </RadioGroup>
        </Col>
        <Col span="24" v-if="requestType=='Reject'" style="margin-top: 4px">
            <Input type="textarea" :rows="4" placeholder="Enter reject note"
                   v-model="rejectNote"></Input>
        </Col>
        <Col span="24" style="margin-top: 10px">
            <Button type="primary" @click="onUpdate()" :loading="loading">
                <span v-if="!loading">Update</span>
                <span v-else>Loading...</span>
            </Button>
        </Col>
    </Row>
</div>
</template>

<script>
  import {ADD_ORDER_DETAIL_UPDATE_ORDER, REJECT_ORDER} from '../../graphql/mutations/orderDetails'
  import {UPDATE_ORDER_BY_STATUS, UPDATE_ORDER_INSERT_CLIENT_INVOICE} from "../../graphql/mutations/orders"
  import {GET_ORDER_DETAIL} from '../../graphql/queries/OrderDetails'
  import {generateUUID, Constants} from "../../Constants/Constant"
  import moment from "moment";
    export default {
        name: "PendingForm",
        props:['orderId', 'order'],
        inject: ["setManageOrderDrawer"],
        data: function(){
            return{
                Constants: Constants,
                moment: moment,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                mutation_ADD_ORDER_DETAIL_UPDATE_ORDER: ADD_ORDER_DETAIL_UPDATE_ORDER,
                query_GET_ORDER_DETAIL: GET_ORDER_DETAIL,
                requestType: 'Approve',
                rejectNote:'',
                loading: false
            }
        },
        methods:{
            resetForm(){
              this.requestType = 'Approve';
              this.rejectNote = '';
            },
            onUpdate(){
                if(this.requestType === 'Approve'){
                    this.approveOrderWithInsertClientInvoice()
                }else{
                    this.rejectOrder()
                }
            },
            async approveOrderWithInsertClientInvoice(){         /* When Approve Order */
              this.loading = true;
              let response = await this.$apollo.mutate({
                mutation: UPDATE_ORDER_INSERT_CLIENT_INVOICE,
                variables: {
                  id: this.orderId,
                  order: {
                    internalstatus: Constants.internalStatus.pendingForOrderConfirmation,
                    lastStageUpdatedOn: moment().format(), lastStageUpdatedBy: this.userObj.user.id
                  },
                  clientInvoice: {
                    statusId: Constants.ClientInvoiceStatus.New, orderId: this.orderId, clientId: this.order.clientobject.id,
                    createdBy: this.userObj.user.id, updatedBy: this.userObj.user.id
                  },
                }
              });
              if(response.data) {
                this.$Message.success('Order updated successfully!');
                this.loading = false;
              }
            },
            async updateOrder(){
                this.loading = true
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDER_BY_STATUS,
                    variables: {
                        orderId: this.orderId,
                        internalstatus: Constants.internalStatus.approval,  //Change internalStatusId to specific argument passed
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.loading = false
                }
            },
            async rejectOrder(){
                this.loading = true
                let response = await this.$apollo.mutate({
                    mutation: REJECT_ORDER,
                    variables: {
                        orderId: this.orderId,
                        internalstatus: Constants.internalStatus.rejected,  //Change internalStatusId to specific argument passed
                        rejectionNote: this.rejectNote
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.loading = false
                }
            },
            async addOrderDetail_UpdateOrder(){
              this.loading = true;
            /* -------- Check if any orderDetail already exists on parent orderId ------- */
                let queryResponse = await this.$apollo.query({
                    query: this.query_GET_ORDER_DETAIL,
                    variables: {orderId: this.orderId},
                    fetchPolicy: "network-only"
                })
                if(queryResponse.data.orderDetails.length){
                    this.loading = false
                    return
                }
                /* -------------x----------------x-------------------x---------------x--------- */
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_ORDER_DETAIL_UPDATE_ORDER,
                    variables: {
                        id: generateUUID(),
                        orderReadiness: {
                            isOrderReady: false,
                            pickupDate: ''
                        },
                        lrObject: {
                            islrReady: false,
                            isEmailSent: false
                        },
                        pickupConfirmation: 'Awaiting',
                        pickupPoint: {
                            pickupPartyName: '',
                            pickupPartyId: '',
                            mobile: '',
                            email: '',
                            add1: '',
                            add2: '',
                            area: '',
                            pincode: '',
                            city: '',
                            state: ''
                        },
                        dropPoint: {
                            dropPartyName: '',
                            dropPartyId: '',
                            mobile: '',
                            email: '',
                            add1: '',
                            add2: '',
                            area: '',
                            pincode: '',
                            city: '',
                            state: ''
                        },
                        orderId: this.orderId,
                        orderDetailId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        internalstatus: this.requestType==='Approve' ? '98d24789-d38d-4426-b6bc-1be53a18fb80' //assign appove internalStatusId
                            : '912cba99-37cb-41fb-ae2e-2a472200af64', //else assign reject internalStatusId
                        rejectionNote: this.requestType!=='Approve' ? this.rejectionNote : ''
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.resetForm();
                    this.setManageOrderDrawer(false)
                    this.loading = false
                }
            },
        }
    }
</script>

<style scoped>

</style>
